import {
    createStructuredSelector
} from "reselect";

const getSuggestCharity = state => state.suggestACharity;
const getZipCode = state => {
    return state.zipCode;
};
const getCountries = state => {
    return getSuggestCharity(state).countries;
};

const getStateList = state => {
    return getSuggestCharity(state).states;
};
const getValidation = state => {
    return getSuggestCharity(state).validation;
};
const getSuggestPost = state => {
    return getSuggestCharity(state).suggestPost;
};
const getSaveCharity = state => {
    return getSuggestCharity(state).savedCharity;
};
const getZipCodes = state => {
    return getZipCode(state).zipCodes;
};

export const suggestAcharityDerivedStates = createStructuredSelector({
    countryList: getCountries,
    statesList: getStateList,
    valid: getValidation,
    suggestPost: getSuggestPost,
    savedCharity: getSaveCharity,
    zipCodeData: getZipCodes
});
